import React from "react";

export function Card({ label, value, sub, icon: Icon, accent = "text-fa-yellow", testid }) {
    return (
        <div className="border border-white/10 bg-[#0d0d0d] p-4 space-y-1" data-testid={testid}>
            <div className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-widest text-white/40">
                {Icon && <Icon size={11} weight="fill" className={accent} />}
                {label}
            </div>
            <div className={`font-display font-black text-2xl tabular-nums ${accent}`}>{value}</div>
            {sub && <div className="font-mono text-[10px] text-white/50 tabular-nums">{sub}</div>}
        </div>
    );
}

export function TopList({ title, rows, icon: Icon, keyName = "id", accent = "text-fa-mint", testid, playerLookup }) {
    if (!rows?.length) {
        return (
            <div className="border border-white/10 bg-[#0d0d0d] p-4 text-center font-mono text-[10px] text-white/40">
                {title}: žádná data
            </div>
        );
    }
    return (
        <div className="border border-white/10 bg-[#0d0d0d] p-4 space-y-2" data-testid={testid}>
            <h3 className="font-display font-black uppercase tracking-tight text-sm flex items-center gap-2">
                {Icon && <Icon size={12} weight="fill" className={accent} />}
                {title}
            </h3>
            <ul className="space-y-1">
                {rows.map((r, i) => {
                    const id = r[keyName];
                    const info = playerLookup ? playerLookup[String(id)] : null;
                    const label = info
                        ? `${info.web_name || info.full_name}${info.team ? ` · ${info.team}` : ""}`
                        : (r.label || `id:${id}`);
                    return (
                        <li key={id ?? i} className="flex items-center justify-between gap-2 border-b border-white/5 pb-1 last:border-none">
                            <div className="flex items-center gap-2 min-w-0">
                                <span className="font-mono text-[10px] text-white/40 tabular-nums w-6">#{i + 1}</span>
                                <span className="font-display font-bold text-sm truncate">{label}</span>
                                {(info?.position || r.position) && (
                                    <span className="font-mono text-[8px] uppercase border border-white/20 text-white/50 px-1 py-0.5">{info?.position || r.position}</span>
                                )}
                            </div>
                            <div className="flex items-center gap-3 shrink-0">
                                {r.pct !== undefined && r.pct !== null && (
                                    <span className={`font-mono text-[10px] tabular-nums ${accent}`}>{r.pct}%</span>
                                )}
                                <span className="font-mono text-[11px] tabular-nums text-white/70">{r.count ?? r.views ?? 0}</span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export function BarSeries({ rows, title, colorClass = "bg-fa-mint/80", testid }) {
    if (!rows?.length) {
        return (
            <div className="border border-white/10 bg-[#0d0d0d] p-4 text-center font-mono text-[10px] text-white/40">
                {title}: žádná data
            </div>
        );
    }
    const max = Math.max(...rows.map((d) => d.count), 1);
    return (
        <div className="border border-white/10 bg-[#0d0d0d] p-4 space-y-3" data-testid={testid}>
            <h3 className="font-display font-black uppercase tracking-tight text-sm">{title}</h3>
            <div className="flex items-end gap-0.5 h-28">
                {rows.map((d) => (
                    <div key={d.date} className="flex-1 flex flex-col items-center group relative">
                        <div
                            className={`w-full ${colorClass} group-hover:brightness-125`}
                            style={{ height: `${Math.max(4, (d.count / max) * 100)}%`, minHeight: "3px" }}
                        />
                        <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-black border border-white/20 px-2 py-1 text-[10px] font-mono whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none z-10">
                            {d.date}: <span className="tabular-nums">{d.count}</span>
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex justify-between font-mono text-[9px] text-white/40 tabular-nums">
                <span>{rows[0].date}</span>
                <span>{rows[rows.length - 1].date}</span>
            </div>
        </div>
    );
}
